/**
 * Created by i.lovenkov on 26.04.17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LangConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LangConstants = exports.LangConstants = (0, _keymirror2.default)({
  LOAD_DATA: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/lang.js
// module id = 1871
// module chunks = 0